import * as React from 'react'

import { ParentMobileMonthlyReserveListItem } from '~/organisms/reserve/ParentMobileMonthlyReserveListItem'
import * as Style from './style.css'

export interface IProps {
  currentReserves: IReserveSummary[]
  yearMonths: { year: number; month: number }[]
  currentMonth: number
  currentYear: number
}

export const ParentMobileMonthlyReserveList = ({
  currentReserves,
  ...props
}: IProps): JSX.Element => (
  <>
    {props.yearMonths.map((yearMonth) => {
      const isActive =
        props.currentYear === yearMonth.year &&
        props.currentMonth === yearMonth.month
      return (
        <div
          className={Style.ListItem}
          key={`${yearMonth.year}${yearMonth.month}`}
        >
          <ParentMobileMonthlyReserveListItem
            reserves={isActive ? currentReserves : []}
            {...yearMonth}
            isActive={isActive}
          />
        </div>
      )
    })}
  </>
)
